module.exports = __webpack_public_path__ + "static/media/adivina-numero.0927b6a0.png";